/* src/app/pages/fotos/formfotos/formfotos.component.scss */
/*# sourceMappingURL=formfotos.component.css.map */
